import { useTranslation } from 'react-i18next'

import { Widget } from '../../../../Widget'
import { useListingProfileContext } from '../RentalPortalListingProfile.hooks'

import { ListingProfileWidgetPortalsRow } from './ListingProfileWidgetPortalsRow'
import { QA_NAME_LISTING_PROFILE_WIDGET_PORTALS } from './RentalPortalListingProfileWidgetPortals.constants'
import { getListingPortalPublications } from './RentalPortalListingProfileWidgetPortals.utils'

import * as styles from './RentalPortalListingProfileWidgetPortals.module.css'

function RentalPortalListingProfileWidgetPortals() {
  const { t } = useTranslation()

  const { isInitiated, listingData } = useListingProfileContext()

  const publications = getListingPortalPublications(listingData)

  return !isInitiated || publications.length > 0 ? (
    <Widget
      contentContainerProps={{ className: styles.content }}
      headerProps={{ contentProps: { actionsProps: { EditButton: null } } }}
      isSkeleton={!isInitiated}
      qaName={QA_NAME_LISTING_PROFILE_WIDGET_PORTALS}
      title={t('RentalPortal.ListingProfilePortalsWidgetTitleKey')}
    >
      {publications.map(publication => (
        <ListingProfileWidgetPortalsRow
          key={publication.id}
          publication={publication}
        />
      ))}
    </Widget>
  ) : null
}

export default RentalPortalListingProfileWidgetPortals
